import $ from 'jquery';
import Swiper from 'swiper';
import {Autoplay, Navigation, Pagination, Scrollbar} from 'swiper/modules';
// import Swiper styles
import 'swiper/css';
//import 'swiper/css/navigation';
import 'swiper/css/pagination';
//import 'swiper/css/scrollbar';

$(document).ready(function () {

    const servicesSwiper = new Swiper('.servicesCarousel .swiper', {
        modules: [Navigation, Pagination, Scrollbar, Autoplay],
        spaceBetween: 30,
        autoplay: {
            pauseOnMouseEnter: true
        },
        loop: false,
        breakpoints: {
            720: {
                slidesPerView: 2,
                spaceBetween: 20
            }
        },
        navigation: {
            nextEl: '.servicesCarousel__next',
            prevEl: '.servicesCarousel__prev',
        },
        scrollbar: {
            el: '.servicesCarousel__scrollbar',
            draggable: true,
            hide: false,
        }
    });


    const portfolioSwiper = new Swiper('.portfolioCarousel__swiper', {
        modules: [Scrollbar, Autoplay],
        spaceBetween: 30,
        autoplay: {
            pauseOnMouseEnter: true
        },
        loop: false,
        breakpoints: {
            720: {
                slidesPerView: 2,
                spaceBetween: 20
            }
        },
        scrollbar: {
            el: '.portfolioCarousel__scrollbar',
            draggable: true,
            hide: false,
        }
    });


    const testimonialsSwiper = new Swiper('.testimonialsCarousel__swiper', {
        modules: [Autoplay],
        spaceBetween: 40,
        autoplay: {
            pauseOnMouseEnter: true
        },
        loop: true,
        autoHeight: true,
        breakpoints: {
            720: {
                spaceBetween: 40
            },
            1200: {
                reverseDirection: true,
                //spaceBetween: 20,
                initialSlide: 1
            }
        }
    });



})

